// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsPoolGetBody = {
  poolId: string;
};

export type typeStripsPoolGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    settings: {
      leagueKey: string;
      leagueId: string;
      firstEventId: string;
      maxSpotsPerMember?: number | null;
      hasLeague?: boolean;
    };
    games: {
      eventId: string;
      stripCardId: string;
      label: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      homeTeamId: string;
      awayTeamId: string;
      homeTeamName: string;
      awayTeamName: string;
      homeTeamAbbreviation: string;
      awayTeamAbbreviation: string;
      isCanceled: boolean;
      stripCount: number;
      lockedStripCount: number;
      mySpotCount: number;
      isCustom: boolean;
    }[];
    selectedEventId?: string | null;
    viewer: { canManage: boolean; maxSpotsPerMember?: number | null };
  };
};

export type typeStripsPoolGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsPoolGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsPoolGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsPoolGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsPoolGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsPoolGetBody);
  }

  return async function postStripsPoolGet(
    payload: typeStripsPoolGetBody,
  ): Promise<typeStripsPoolGetOutput200 | typeStripsPoolGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsPoolGet" failed before calling the network. #beaaf5a6813d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#beaaf5a6813d" },
        },
        data: null,
      } as typeStripsPoolGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/pool-get`,
      httpMethod: "POST",
      options,
    })) as typeStripsPoolGetOutput200 | typeStripsPoolGetOutput400;
  };
}
